import { render, staticRenderFns } from "./HomeworkCollapseList.vue?vue&type=template&id=2738ec6b&"
import script from "./HomeworkCollapseList.vue?vue&type=script&lang=js&"
export * from "./HomeworkCollapseList.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkCollapseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports